// App-wide constants

export const REDIRECT_URL_KEY = 'redirectUrl'
export const PERSIST_STORE_NAME = 'sms-app-store'
export const APP_NAME = 'School Management System'
export const APP_SHORT_NAME = 'SMS'
